<template>
  <div class="table-container">
    <VcaTable
      store="crews"
      :list="getList()"
      :colspan="7"
      :searchLabel="$t('network.crews.list.search')"
    >
      <template v-slot:colspan>
        <col width="1%" />
        <col width="20%" />
        <col width="20%" />
        <col width="38%" />
        <col width="20%" />
        <col width="1%" />
      </template>

      <template v-slot:desktop-filter>
        <vca-accordion :header="$t('network.crews.list.filter')">
          <div slot="body">
            <CrewFilter v-model="filter" />
          </div>
        </vca-accordion>
      </template>

      <template v-if="selected.length > 0" v-slot:desktop-options>
        <CsvExport :data="exportData" :labels="exportLabels">
          <button class="vca-button-small table-header-option">
            {{ $t("button.export") }}
          </button>
        </CsvExport>
      </template>

      <template v-slot:desktop-header>
        <th class="vca-table-check">
          <label><vca-checkbox v-model="all_selected" /></label>
        </th>
        <th class="vca-table-cell sortable" @click="sort('name')">
          <label> {{ $t("network.crews.list.name") }} &varr;</label>
        </th>
        <th class="vca-table-cell sortable" @click="sort('email')">
          <label> {{ $t("network.crews.list.email") }} &varr;</label>
        </th>
        <th class="vca-table-cell">
          <label class="vca-left"> {{ $t("network.crews.list.cities") }}</label>
        </th>
        <th class="vca-table-cell">
          <label class="vca-left"> {{ $t("organisation.context") }}</label>
        </th>
        <th class="vca-table-cell">
          <label>{{ $t("table.options") }}</label>
        </th>
      </template>

      <template v-slot:desktop-content>
        <tr
          class="vca-table-row"
          :class="{ last: index + 1 == pg.pageSize }"
          v-for="(res, index) in getList()"
          :key="index"
        >
          <td class="vca-table-check">
            <label><vca-checkbox v-model="selected" :id="res.id" /></label>
          </td>
          <td class="vca-table-cell">
            <label> {{ res.name }} ({{ res.abbreviation }})</label>
          </td>
          <td class="vca-table-cell">
            <label> {{ res.email }} </label>
          </td>
          <td class="vca-table-cell">
            <label class="vca-left">
              {{ getCityList(res.cities) }}
            </label>
          </td>
          <td class="vca-table-cell">
            <label> {{ res.organisation.name }} </label>
          </td>
          <td class="vca-table-cell">
            <label class="table-options">
              <img
                @click="setCurrent(res)"
                class="editable"
                src="@/assets/icons/edit.png"
                :title="$t('button.edit')"
                :alt="$t('button.edit')"
              />
              <img
                @click="setCurrentView(res)"
                class="editable apply-filter"
                src="@/assets/icons/public.svg"
                :title="$t('button.view')"
                :alt="$t('button.view')"
              />
            </label>
          </td>
        </tr>
      </template>

      <template v-slot:mobile-filter>
        <button class="vca-button" @click="do_filter = true">
          {{ $t("network.crews.list.filter") }}
        </button>
        <vca-popup
          v-if="do_filter"
          :show="do_filter"
          :title="$t('network.crews.list.filter')"
          @close="do_filter = false"
        >
          <CrewFilter v-model="filter" />
        </vca-popup>
      </template>

      <template v-slot:mobile-header>
        <div class="sortable" @click="sort('name')">
          <label>{{ $t("network.crews.list.name") }} &varr;</label>
        </div>
      </template>

      <template v-slot:mobile-content>
        <tr
          @click="setCurrent(res)"
          class="vca-table-row"
          :class="{ last: index + 1 == pg.pageSize }"
          v-for="(res, index) in getList()"
          :key="index"
        >
          <td class="vca-table-cell">
            <vca-column>
              <h3 class="vca-table-index">{{ res.name }}</h3>
              <div>{{ res.email }}</div>
              <div>{{ getCityList(res.cities) }}</div>
            </vca-column>
          </td>
        </tr>
      </template>
    </VcaTable>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import VcaTable from "@/components/utils/VcaTable";
import CsvExport from "@/components/utils/CsvExport";
import CrewFilter from "@/components/network/crews/list/CrewFilter";
export default {
  name: "NetworkCrewsTable",
  components: { VcaTable, CsvExport, CrewFilter },
  data() {
    return {
      all_selected: false,
      selected: [],
      store: "crews/pg",
      initial: true,
      do_filter: false,
      currentFilter: {},
      currentTextFilter: "",
    };
  },
  watch: {
    pg: {
      handler(val) {
        this.$store.commit(this.store + "/pagination", val);
      },
      deep: true,
    },
    all_selected: function (nVal) {
      this.selected = nVal ? this.getList().map((el) => el.id) : [];
    },
  },
  created() {
    this.filter = {
      entities: [],
      organisations: [],
    };
  },
  computed: {
    filter: {
      set(value) {
        this.pg.filterObject = value;
      },
      get() {
        return this.pg.filterObject;
      },
    },
    ...mapState({
      pg(state, getters) {
        if (this.store) {
          return getters[`${this.store}/pagination`];
        }
      },
    }),
    ...mapGetters({
      list: "crews/list",
      entities: "crews/entities",
    }),
    emptyFilter() {
      return (
        (!this.pg.filter || this.pg.filter == "") &&
        this.filter.entities.length == 0 &&
        this.filter.organisations.length == 0
      );
    },
    sameFilter() {
      return (
        Object.entries(this.currentFilter).toString() ===
          Object.entries(this.filter).toString() &&
        this.currentTextFilter == this.pg.filter
      );
    },
    exportData() {
      let list = this.getList().filter((el) => {
        return this.selected.includes(el.id);
      });
      if (list) {
        return list.map((el) => ({
          name: el.name,
          cities: this.getCityList(el.cities),
        }));
      } else {
        return [];
      }
    },
    exportLabels() {
      return {
        name: this.$t("network.crews.list.name"),
        cities: this.$t("network.crews.list.cities"),
      };
    },
  },
  methods: {
    setCurrent(value) {
      if (this.current && this.current.id == value.id) {
        this.$store.commit("crews/current", null);
      } else {
        this.$store.commit("crews/current", { ...value });
      }
    },
    setCurrentView(value) {
      this.$router.push({ path: "/network/crews/" + value.id });
    },
    getCityList(value) {
      return value.map((el) => el.city + " (" + el.country + ")").join(", ");
    },
    getCountrys(value) {
      const unique = [
        ...new Set(value.cities.map((item) => item.country_code.toLowerCase())),
      ]; // [ 'A', 'B']
      return unique;
    },
    getList() {
      // If the list is empty, we have an empty array
      if (!this.list) {
        return [];
      }

      // If the current page is out of scope, set it to last page
      if (this.pg.currentPage > this.pg.pageCount) {
        this.$store.commit(this.store + "/prevPage");
      }

      // Create a list for filtering and start filtering
      var filteredList = this.list;

      filteredList = filteredList.filter((row, index) => {
        // Add a rank to the current entry
        row.rank = index + 1;

        // If the filter is empty, everything is fine
        if (this.emptyFilter) {
          return true;
        }

        if (this.filter.entities != 0) {
          if (
            !this.getCountrys(row).find((el) =>
              this.filter.entities.includes(el)
            )
          ) {
            return false;
          }
        }

        if (this.filter.organisations != 0) {
          if (!this.filter.organisations.includes(row.organisation_id)) {
            return false;
          }
        }

        // Filter for the current value of row.team_name
        const search = this.pg.filter.toLowerCase().trim();
        return (
          row.name.toLowerCase().indexOf(search) > -1 ||
          this.getCityList(row.cities).toLowerCase().indexOf(search) > -1 ||
          row.email.toLowerCase().indexOf(search) > -1
        );
      });

      // Set the length of the list to the current filtered list
      this.pg.listLength = filteredList.length == 0 ? 1 : filteredList.length;
      if (
        this.pg.listLength < this.pg.pageSize ||
        this.pg.pageSize > filteredList.length
      ) {
        // If the length is smaller than the current page size, we adjust the pagesize to the length of the filtered list
        this.pg.pageSize = this.pg.listLength;
      } else if (!this.sameFilter || this.initial) {
        // If the filter has changed, we resize the list
        this.initial = false;
        this.pg.pageSize =
          this.pg.currentPageSize > this.pg.listLength
            ? this.pg.listLength
            : this.pg.currentPageSize;
      }
      // Set the new filters
      if (!this.sameFilter) {
        this.currentTextFilter = this.pg.filter;
        this.currentFilter = JSON.parse(JSON.stringify(this.filter));
      }

      // Now we filter the list to the current pageSize and paginate it
      return filteredList.filter((row, index) => {
        let start = (this.pg.currentPage - 1) * this.pg.pageSize;
        let end = this.pg.currentPage * this.pg.pageSize;
        if (index >= start && index < end) return true;
      });
    },
    sort(col) {
      // When sorting, we set the current page to 1
      this.$store.commit(this.store + "/firstPage");

      // If we have an empty list, return an empty array
      if (!this.list) {
        return [];
      }

      // Define the sorting direction, if current sort is the same as the column to sort, then switch direction
      if (this.pg.currentSort === col) {
        this.pg.currentSortDir =
          this.pg.currentSortDir === "asc" ? "desc" : "asc";
      } else {
        this.pg.currentSort = col;
      }

      // Sort the list depending on the column and the direction
      this.list.sort((a, b) => {
        var final_key = this.pg.currentSort;

        // Sort nested objects if sorting column contains a dot (.)
        if (col.indexOf(".") !== -1) {
          var column = col.split(".");
          var len = column.length;
          var i = 0;
          while (i < len - 1) {
            a = a[column[i]];
            b = b[column[i]];
            i++;
            final_key = column[i];
          }
        }

        // Set zero 0 at the end
        // if (parseInt(a[final_key]) == 0) return 1;
        // if (parseInt(b[final_key]) == 0) return -1;

        // Comapre integer values
        if (
          a[final_key] === parseInt(a[final_key], 10) ||
          a[final_key] === parseFloat(a[final_key], 10)
        ) {
          return this.pg.currentSortDir === "desc"
            ? a[final_key] - b[final_key]
            : b[final_key] - a[final_key];
        }

        // Compare string values
        let modifier = 1;
        if (this.pg.currentSortDir === "desc") modifier = -1;
        if (a[final_key].toLowerCase() < b[final_key].toLowerCase())
          return -1 * modifier;
        if (a[final_key].toLowerCase() > b[final_key].toLowerCase())
          return 1 * modifier;
        return 0;
      });
    },
  },
};
</script>
